import { ACCOUNT_SIZE, AccountState } from '@solana/spl-token';

// Token-2022 stores a 1-byte AccountType marker right after ACCOUNT_SIZE in the
// mint buffer; TLV entries follow. Each entry: 2-byte type LE, 2-byte length LE,
// then `length` bytes of payload.
const ACCOUNT_TYPE_SIZE = 1;
const TLV_HEADER_LEN = 4;

// ExtensionType.DefaultAccountState in @solana/spl-token is 6 — verified
// against the program's interface crate and the published d.ts.
export const DEFAULT_ACCOUNT_STATE_EXTENSION_TYPE = 6;

export interface DefaultAccountStateConfig {
  state: AccountState;
}

export { AccountState };

export function parseDefaultAccountStateFromMint(
  buffer: Buffer,
): DefaultAccountStateConfig | null {
  const tlvStart = ACCOUNT_SIZE + ACCOUNT_TYPE_SIZE;
  if (buffer.length <= tlvStart) { return null; }

  let cursor = tlvStart;
  while (cursor + TLV_HEADER_LEN <= buffer.length) {
    const type = buffer.readUInt16LE(cursor);
    const length = buffer.readUInt16LE(cursor + 2);
    const dataStart = cursor + TLV_HEADER_LEN;
    const dataEnd = dataStart + length;
    if (dataEnd > buffer.length) { return null; }

    if (type === DEFAULT_ACCOUNT_STATE_EXTENSION_TYPE) {
      if (length < 1) { return null; }
      const raw = buffer.readUInt8(dataStart);
      // Anything outside the known enum range gets clamped to Initialized so
      // downstream UI gates ("state === Frozen") never accidentally match.
      const state: AccountState = raw === AccountState.Frozen
        ? AccountState.Frozen
        : raw === AccountState.Uninitialized
        ? AccountState.Uninitialized
        : AccountState.Initialized;
      return { state };
    }

    if (type === 0 && length === 0) {
      cursor += TLV_HEADER_LEN;
      continue;
    }
    cursor = dataEnd;
  }

  return null;
}
